<template>
  <div>
    <br />
    <div class="d-flex justify-content-center">
      <span class="p-2 fs-5">
        Vente Vendeur Référence Nº :
        <span class="fw-bold fs-5">
          {{ $route.params.reference }}
        </span>
        <span class="fw-bold text-dark fs-5">
          {{ sellerSale.date }}
        </span>
      </span>
    </div>
    <div class="d-flex justify-content-center align-items-center p-0">
      <div class="col-auto row">
        <div
          v-if="sellerSale.reference && $userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button
            @click="
              $router.push({
                name: 'seller-sales-edit',
                params: { reference: sellerSale.reference },
              })
            "
            class="btn border"
          >
            <i class="bi bi-pencil-square text-secondary fs-4"></i> Modifier
          </button>
        </div>

        <div
          v-if="sellerSale.reference && $userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button
            @click="remove(sellerSale.reference)"
            class="btn border border-danger text-danger"
          >
            <i class="bi bi-archive-fill text-danger fs-4"></i> Supprimer
          </button>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-3 col-12 my-3">
        <label for=""> Référence </label>
        <div>
          {{ sellerSale.reference }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Client Vendeur </label>
        <div>
          {{ sellerSale.sellerCustomer && sellerSale.sellerCustomer.fullName }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Date</label>
        <div>
          {{ sellerSale.date }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Échéance</label>
        <div>
          {{ sellerSale.deadline }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Date de livraison</label>
        <div>
          {{ sellerSale.deliveryDateTime }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Total TTC</label>
        <div>
          {{ sellerSale.totalPriceTTC }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Total HT</label>
        <div>
          {{ sellerSale.totalPriceHT }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Total TVA</label>
        <div>
          {{ sellerSale.totalPriceTVA }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Quantité Totale</label>
        <div>
          {{ sellerSale.totalQuantity }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Montant Payé</label>
        <div>
          {{ sellerSale.amountPaid }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Montant Impayé</label>
        <div>
          {{ sellerSale.amountUnpaid }}
        </div>
      </div>

      <div class="col-xl-12 col-12 my-3">
        <label for=""> Remarque </label>
        <div>
          {{ sellerSale.remark }}
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <h5>Articles de la vente</h5>
        <vue-data-table
          v-if="sellerSale.saleItems && sellerSale.saleItems.length"
          :headers="itemHeaders"
          :data="sellerSale.saleItems"
          :items-per-page="10"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      itemHeaders: [
        { label: "Article", field: "item.fullName", class: "text-left" },
        { label: "Prix HT", field: "priceHT", class: "text-right" },
        { label: "Prix TTC", field: "priceTTC", class: "text-right" },
        { label: "Quantité", field: "quantity", class: "text-right" },
        { label: "Total HT", field: "totalPriceHT", class: "text-right" },
        { label: "Total TTC", field: "totalPriceTTC", class: "text-right" },
        { label: "Remarque", field: "remark", class: "text-left" },
      ],
    };
  },
  computed: {
    ...mapGetters("sellerSale", {
      sellerSale: "getSellerSale",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),
  },
  methods: {
    async remove(reference) {
      await this.$store.dispatch("sellerSale/destroy", reference);
    },
    async referesh() {
      await this.$store.dispatch(
        "sellerSale/show",
        this.$route.params.reference
      );
    },
  },
  beforeMount() {
    this.$store.dispatch("sellerSale/show", this.$route.params.reference);
  },
};
</script>
